// extracted by mini-css-extract-plugin
module.exports = {"Card":"styles-module--Card--3Hr7e","SubMain":"styles-module--SubMain--uAa1t","Layout":"styles-module--Layout--2S6FA"};